/*
 *
 * ActivityPage actions
 *
 */

const SCOPE = 'app/ActivityPage/';
export const ActionTypes = {
    ADD_TO_CART: `${SCOPE}ADD_TO_CART`,
    SET_ADD_TO_CART: `${SCOPE}SET_ADD_TO_CART`,
    SET_PARAMS: `${SCOPE}SET_PARAMS`,
    SET_IS_404: `${SCOPE}SET_IS_404`,
    RESET_CONTENTS: `${SCOPE}RESET_CONTENTS`,

    SET_PAGE_IS_LOADED: `${SCOPE}SET_PAGE_IS_LOADED`,
    FETCH_PAGE: `${SCOPE}FETCH_PAGE`,
    FETCH_PAGE_STARTED: `${SCOPE}FETCH_PAGE_STARTED`,
    FETCH_PAGE_SUCCESSFULLY: `${SCOPE}FETCH_PAGE_SUCCESSFULLY`,
    FETCH_PAGE_FAILED: `${SCOPE}FETCH_PAGE_FAILED`,
    FETCH_PAGE_CANCELLED: `${SCOPE}FETCH_PAGE_CANCELLED`,

    SET_STORIES_IS_LOADED: `${SCOPE}SET_STORIES_IS_LOADED`,
    FETCH_STORIES: `${SCOPE}FETCH_STORIES`,
    FETCH_STORIES_STARTED: `${SCOPE}FETCH_STORIES_STARTED`,
    FETCH_STORIES_SUCCESSFULLY: `${SCOPE}FETCH_STORIES_SUCCESSFULLY`,
    FETCH_STORIES_FAILED: `${SCOPE}FETCH_STORIES_FAILED`,
    FETCH_STORIES_CANCELLED: `${SCOPE}FETCH_STORIES_CANCELLED`,

    SET_RECOMMENDS_IS_LOADED: `${SCOPE}SET_RECOMMENDS_IS_LOADED`,
    FETCH_RECOMMENDS: `${SCOPE}FETCH_RECOMMENDS`,
    FETCH_RECOMMENDS_STARTED: `${SCOPE}FETCH_RECOMMENDS_STARTED`,
    FETCH_RECOMMENDS_SUCCESSFULLY: `${SCOPE}FETCH_RECOMMENDS_SUCCESSFULLY`,
    FETCH_RECOMMENDS_FAILED: `${SCOPE}FETCH_RECOMMENDS_FAILED`,
    FETCH_RECOMMENDS_CANCELLED: `${SCOPE}FETCH_RECOMMENDS_CANCELLED`,

    SET_AVAILABILITY_IS_LOADED: `${SCOPE}SET_AVAILABILITY_IS_LOADED`,
    SET_AVAILABILITY_PROGRESS: `${SCOPE}SET_AVAILABILITY_PROGRESS`,
    CHECK_AND_REFETCH_AVAILABILITY: `${SCOPE}CHECK_AND_REFETCH_AVAILABILITY`,
    FETCH_AVAILABILITY: `${SCOPE}FETCH_AVAILABILITY`,
    FETCH_AVAILABILITY_STARTED: `${SCOPE}FETCH_AVAILABILITY_STARTED`,
    FETCH_AVAILABILITY_SUCCESSFULLY: `${SCOPE}FETCH_AVAILABILITY_SUCCESSFULLY`,
    FETCH_AVAILABILITY_FAILED: `${SCOPE}FETCH_AVAILABILITY_FAILED`,
    FETCH_AVAILABILITY_CANCELLED: `${SCOPE}FETCH_AVAILABILITY_CANCELLED`,

    SET_UNAVAILABLE_IS_LOADED: `${SCOPE}SET_UNAVAILABLE_IS_LOADED`,
    RESET_UNAVAILABLE: `${SCOPE}RESET_UNAVAILABLE`,
    CHECK_AND_REFETCH_UNAVAILABLE: `${SCOPE}CHECK_AND_REFETCH_UNAVAILABLE`,
    FETCH_UNAVAILABLE: `${SCOPE}FETCH_UNAVAILABLE`,
    FETCH_UNAVAILABLE_STARTED: `${SCOPE}FETCH_UNAVAILABLE_STARTED`,
    FETCH_UNAVAILABLE_SUCCESSFULLY: `${SCOPE}FETCH_UNAVAILABLE_SUCCESSFULLY`,
    FETCH_UNAVAILABLE_FAILED: `${SCOPE}FETCH_UNAVAILABLE_FAILED`,
    FETCH_UNAVAILABLE_CANCELLED: `${SCOPE}FETCH_UNAVAILABLE_CANCELLED`,

    SET_USER_IMAGES_IS_LOADED: `${SCOPE}SET_USER_IMAGES_IS_LOADED`,
    FETCH_USER_IMAGES: `${SCOPE}FETCH_USER_IMAGES`,
    FETCH_USER_IMAGES_STARTED: `${SCOPE}FETCH_USER_IMAGES_STARTED`,
    FETCH_USER_IMAGES_SUCCESSFULLY: `${SCOPE}FETCH_USER_IMAGES_SUCCESSFULLY`,
    FETCH_USER_IMAGES_FAILED: `${SCOPE}FETCH_USER_IMAGES_FAILED`,
    FETCH_USER_IMAGES_CANCELLED: `${SCOPE}FETCH_USER_IMAGES_CANCELLED`,

    SET_CONFIG_IS_LOADED: `${SCOPE}SET_CONFIG_IS_LOADED`,
    FETCH_CONFIG: `${SCOPE}FETCH_CONFIG`,
    FETCH_CONFIG_STARTED: `${SCOPE}FETCH_CONFIG_STARTED`,
    FETCH_CONFIG_SUCCESSFULLY: `${SCOPE}FETCH_CONFIG_SUCCESSFULLY`,
    FETCH_CONFIG_FAILED: `${SCOPE}FETCH_CONFIG_FAILED`,
    FETCH_CONFIG_CANCELLED: `${SCOPE}FETCH_CONFIG_CANCELLED`,

    CHANGE_ADD_TRIPFLEX: `${SCOPE}CHANGE_ADD_TRIPFLEX`,
    SET_IS_VALID_TICKET: `${SCOPE}SET_IS_VALID_TICKET`,
    SET_PAYLOAD: `${SCOPE}SET_PAYLOAD`,
};

/**
 * Common
 */
export const setIs404 = (is404) => ({
    type: ActionTypes.SET_IS_404,
    is404,
});

export const setParams = (params) => ({
    type: ActionTypes.SET_PARAMS,
    params,
});

export const resetContents = () => ({
    type: ActionTypes.RESET_CONTENTS,
});

export const addToCart = (availabilityCalendarData) => ({
    type: ActionTypes.ADD_TO_CART,
    availabilityCalendarData,
});

export const setAddToCart = (isLoading, errorMessage) => ({
    type: ActionTypes.SET_ADD_TO_CART,
    isLoading,
    errorMessage,
});

/**
 * Page
 */
export const setPageIsLoaded = (isLoaded) => ({ type: ActionTypes.SET_PAGE_IS_LOADED, isLoaded });
export const fetchPage = () => ({ type: ActionTypes.FETCH_PAGE });
export const fetchPageStarted = () => ({ type: ActionTypes.FETCH_PAGE_STARTED });
export const fetchPageSuccessfully = (res) => ({
    type: ActionTypes.FETCH_PAGE_SUCCESSFULLY,
    res,
});
export const fetchPageFailed = (error) => ({
    type: ActionTypes.FETCH_PAGE_FAILED,
    error,
});
export const fetchPageCancelled = () => ({
    type: ActionTypes.FETCH_PAGE_CANCELLED,
});

/**
 * Stories
 */
export const setStoriesIsLoaded = (isLoaded) => ({
    type: ActionTypes.SET_STORIES_IS_LOADED,
    isLoaded,
});
export const fetchStories = () => ({ type: ActionTypes.FETCH_STORIES });
export const fetchStoriesStarted = () => ({ type: ActionTypes.FETCH_STORIES_STARTED });
export const fetchStoriesSuccessfully = (res) => ({
    type: ActionTypes.FETCH_STORIES_SUCCESSFULLY,
    res,
});
export const fetchStoriesFailed = (error) => ({
    type: ActionTypes.FETCH_STORIES_FAILED,
    error,
});
export const fetchStoriesCancelled = () => ({
    type: ActionTypes.FETCH_STORIES_CANCELLED,
});

/**
 * Recommends
 */
export const setRecommendsIsLoaded = (isLoaded) => ({
    type: ActionTypes.SET_RECOMMENDS_IS_LOADED,
    isLoaded,
});
export const fetchRecommends = () => ({ type: ActionTypes.FETCH_RECOMMENDS });
export const fetchRecommendsStarted = () => ({ type: ActionTypes.FETCH_RECOMMENDS_STARTED });
export const fetchRecommendsSuccessfully = (res) => ({
    type: ActionTypes.FETCH_RECOMMENDS_SUCCESSFULLY,
    res,
});
export const fetchRecommendsFailed = (error) => ({
    type: ActionTypes.FETCH_RECOMMENDS_FAILED,
    error,
});
export const fetchRecommendsCancelled = () => ({
    type: ActionTypes.FETCH_RECOMMENDS_CANCELLED,
});

/**
 * Unavailable
 */
export const resetUnavailable = () => ({ type: ActionTypes.RESET_UNAVAILABLE });
export const checkAndRefetchUnavailable = (formattedDate) => ({
    type: ActionTypes.CHECK_AND_REFETCH_UNAVAILABLE,
    formattedDate,
});
export const setUnavailableIsLoaded = (formattedDate, isLoaded) => ({
    type: ActionTypes.SET_PAGE_IS_LOADED,
    isLoaded,
    formattedDate,
});
export const fetchUnavailable = (formattedDate) => ({
    type: ActionTypes.FETCH_UNAVAILABLE,
    formattedDate,
});
export const fetchUnavailableStarted = (formattedDate) => ({
    type: ActionTypes.FETCH_UNAVAILABLE_STARTED,
    formattedDate,
});
export const fetchUnavailableSuccessfully = (
    formattedDate,
    formattedDays,
    formattedDateEndOfRequest
) => ({
    type: ActionTypes.FETCH_UNAVAILABLE_SUCCESSFULLY,
    formattedDate,
    formattedDays,
    formattedDateEndOfRequest,
});
export const fetchUnavailableFailed = (formattedDate, error) => ({
    type: ActionTypes.FETCH_UNAVAILABLE_FAILED,
    error,
});
export const fetchUnavailableCancelled = (formattedDate) => ({
    type: ActionTypes.FETCH_UNAVAILABLE_CANCELLED,
    formattedDate,
});

/**
 * Availability
 */
export const setAvailabilityIsLoaded = (isLoaded) => ({
    type: ActionTypes.SET_AVAILABILITY_IS_LOADED,
    isLoaded,
});
export const setAvailabilityProgress = (total, loaded) => ({
    type: ActionTypes.SET_AVAILABILITY_PROGRESS,
    total,
    loaded,
});
export const checkAndRefetchAvailability = () => ({
    type: ActionTypes.CHECK_AND_REFETCH_AVAILABILITY,
});
export const fetchAvailability = () => ({ type: ActionTypes.FETCH_AVAILABILITY });
export const fetchAvailabilityStarted = () => ({ type: ActionTypes.FETCH_AVAILABILITY_STARTED });
export const fetchAvailabilitySuccessfully = (res) => ({
    type: ActionTypes.FETCH_AVAILABILITY_SUCCESSFULLY,
    res,
});
export const fetchAvailabilityFailed = (error) => ({
    type: ActionTypes.FETCH_AVAILABILITY_FAILED,
    error,
});
export const fetchAvailabilityCancelled = () => ({
    type: ActionTypes.FETCH_AVAILABILITY_CANCELLED,
});

/**
 * User images
 */
export const setUserImagesIsLoaded = (isLoaded) => ({
    type: ActionTypes.SET_USER_IMAGES_IS_LOADED,
    isLoaded,
});
export const fetchUserImages = () => ({ type: ActionTypes.FETCH_USER_IMAGES });
export const fetchUserImagesStarted = () => ({ type: ActionTypes.FETCH_USER_IMAGES_STARTED });
export const fetchUserImagesSuccessfully = (res) => ({
    type: ActionTypes.FETCH_USER_IMAGES_SUCCESSFULLY,
    res,
});
export const fetchUserImagesFailed = (error) => ({
    type: ActionTypes.FETCH_USER_IMAGES_FAILED,
    error,
});
export const fetchUserImagesCancelled = () => ({
    type: ActionTypes.FETCH_USER_IMAGES_CANCELLED,
});

/**
 * config
 */
export const setConfigIsLoaded = (isLoaded) => ({
    type: ActionTypes.SET_CONFIG_IS_LOADED,
    isLoaded,
});
export const fetchConfig = () => ({ type: ActionTypes.FETCH_CONFIG });
export const fetchConfigStarted = () => ({ type: ActionTypes.FETCH_CONFIG_STARTED });
export const fetchConfigSuccessfully = (res) => ({
    type: ActionTypes.FETCH_CONFIG_SUCCESSFULLY,
    res,
});
export const fetchConfigFailed = (error) => ({
    type: ActionTypes.FETCH_CONFIG_FAILED,
    error,
});
export const fetchConfigCancelled = () => ({
    type: ActionTypes.FETCH_CONFIG_CANCELLED,
});
/**
 * add_tripflex
 */
export const changeAddTripflex = (add_tripflex) => ({
    type: ActionTypes.CHANGE_ADD_TRIPFLEX,
    add_tripflex,
});
/**
 * Avaibility calendar
 */
export const setIsValidTicket = (isValidTicket) => ({
    type: ActionTypes.SET_IS_VALID_TICKET,
    isValidTicket,
});
export const setPayload = (payload) => ({
    type: ActionTypes.SET_PAYLOAD,
    payload,
});
